/**
 * This component is deprecated and was intended for older implementations of the phone picker.
 * New versions don't use the autocomplete, they have an external list that displays the customers.
 */
import { Autocomplete } from "@material-ui/lab";
import React, { ChangeEvent, useRef } from "react";
import { IDeprecatedAutoCompleteProps } from "./types";
import UtilsService from "external-services/utils-service";
import { ICustomer } from "shared-types/index";
import PhoneNumberService from "external-services/phone-number-service";

export default function DeprecatedAutoComplete({
    TextFieldComponent,
    labelText, value, inputProps,
    textInputClasses, 
    disabled,   
    customers,
    placeholderText,
    name,
    helperText,
    error,
    isRequired,
    country,
    handleChange,
    handleBlur,
    handleWholeFormChangeForAutocomplete,
}: IDeprecatedAutoCompleteProps) {
    const inputRef = useRef(null);

    const formatAutoCompletePhoneNumber = (value: string) => {
        const parseNumber: any = PhoneNumberService.parseNumber(value, true);
        if (parseNumber && typeof parseNumber !== 'string') {
        if (parseNumber.nationalNumber) {
            setTimeout(() => {
            // setSelectedCountry(parseNumber.country);
            handleChange({
                ...{},
                target: {
                    name: name,
                    value: parseNumber.nationalNumber,
                },
            });
            country !== parseNumber.country &&
                handleChange({
                ...{},
                target: {
                    name: 'country',
                    value: parseNumber.country,
                },
                });
            }, 100);
            return parseNumber.nationalNumber;
        } else return value;
        }
        return value;
    };

    return (
        <Autocomplete
          freeSolo
          disabled={disabled}
          disableClearable
          inputValue={value ? formatAutoCompletePhoneNumber(value) : ''}
          onChange={(event: ChangeEvent<{}>, newValue: string | ICustomer) => {
            handleWholeFormChangeForAutocomplete(newValue as ICustomer);
          }}
          renderOption={(option: ICustomer) => (
            <React.Fragment>
              <span>{UtilsService.getDisplayName(option, true)}</span>
            </React.Fragment>
          )}
          getOptionLabel={(option) => option.phone}
          options={customers as ICustomer[]}
          renderInput={(params) => (
            <TextFieldComponent
              classes={textInputClasses}
              data-testid="data-test-id-phone-flag-picker-value"
              {...params}
              label={labelText}
              inputProps={{
                ...params.inputProps,
                ...inputProps
              }}
              placeholder={placeholderText}
              name={name}
              required={isRequired}
              fullWidth
              value={value}
              onChange={handleChange}
              onBlur={handleBlur}
              error={error}
              inputRef={inputRef}
              helperText={helperText}
            />
          )}
          /**
           * should be return all options without own filter inside autocomplete
           */
          filterOptions={(options, state) => {
            return options;
          }}
        />
    )
}